import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import CarLineupFilterItem from '../../containers/car-lineup-filter-item';

const CarLineupFilterItemBlock = props => <CarLineupFilterItem {...props} />;
CarLineupFilterItemBlock.displayName = 'CarLineupFilterItem';

export default withDynamicComponents({
  componentWhitelist: [
  ],
  mapInputToOutput: [
  ],
})(CarLineupFilterItemBlock);



// WEBPACK FOOTER //
// ./src/blocks/car-lineup-filter-item/index.jsx